import { Divider, Stack, Text } from "@mantine/core";
import type { JSX } from "react";

const PageContentSection = ({
  title,
  children,
  isLast,
}: {
  title: string;
  children: JSX.Element;
  isLast?: boolean;
}) => (
  <Stack gap={16}>
    <Text size="sm" fw={600}>
      {title}
    </Text>
    <Divider />
    {children}
    {!isLast && <Divider />}
  </Stack>
);

export default PageContentSection;
